import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const changeLanguage = (language) => {
  i18n.changeLanguage(language);
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    detection: {
      // Order of detection methods
      order: ["localStorage", "cookie", "navigator"],
      // Keys to lookup language from
      lookupLocalStorage: "i18nextLng",
      lookupCookie: "language",
      // Cache user language
      caches: ["localStorage", "cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

// eslint-disable-next-line import/no-anonymous-default-export
export default { changeLanguage, i18n };
